import type {SwimlaneConfig} from "../../types";

// Swimlane configurations for each diagram

// P2P Swimlanes - 7 roles showing segregation of duties in purchasing process
const p2pSwimlanes: SwimlaneConfig[] = [
  {label: "Requestor", color: "#3182CE", minX: -2, maxX: 6}, // Blue
  {label: "Approving Manager", color: "#38A169", minX: 6, maxX: 14}, // Green
  {label: "Procurement Team", color: "#9F7AEA", minX: 14, maxX: 22}, // Purple
  {label: "Receiving Department", color: "#DD6B20", minX: 22, maxX: 30}, // Orange
  {label: "Accounts Payable", color: "#E53E3E", minX: 30, maxX: 38}, // Red
  {label: "Treasury/Payment Auth", color: "#D69E2E", minX: 38, maxX: 46}, // Yellow
  {label: "General Ledger", color: "#319795", minX: 46, maxX: 54}, // Teal
];

// O2C Swimlanes - 8 roles showing revenue cycle segregation of duties
const o2cSwimlanes: SwimlaneConfig[] = [
  {label: "Sales Team", color: "#3182CE", minX: -2, maxX: 6}, // Blue
  {label: "Credit Management", color: "#38A169", minX: 6, maxX: 14}, // Green
  {label: "Sales Management", color: "#9F7AEA", minX: 14, maxX: 22}, // Purple
  {label: "Warehouse/Fulfillment", color: "#DD6B20", minX: 22, maxX: 30}, // Orange
  {label: "Shipping", color: "#E53E3E", minX: 30, maxX: 38}, // Red
  {label: "Billing", color: "#D69E2E", minX: 38, maxX: 46}, // Yellow
  {label: "Treasury/AR", color: "#319795", minX: 46, maxX: 54}, // Teal
  {label: "Accounting", color: "#805AD5", minX: 54, maxX: 62}, // Purple
];

// IT Access Swimlanes - 7 roles showing access management controls
const itAccessSwimlanes: SwimlaneConfig[] = [
  {label: "Requestor", color: "#3182CE", minX: -2, maxX: 6}, // Blue
  {label: "Manager", color: "#38A169", minX: 6, maxX: 14}, // Green
  {label: "System Owner", color: "#9F7AEA", minX: 14, maxX: 22}, // Purple
  {label: "IT Security", color: "#DD6B20", minX: 22, maxX: 30}, // Orange
  {label: "IT Operations", color: "#E53E3E", minX: 30, maxX: 38}, // Red
  {label: "Compliance", color: "#D69E2E", minX: 38, maxX: 46}, // Yellow
  {label: "HR", color: "#319795", minX: 46, maxX: 54}, // Teal
];

// Map of diagram IDs to their swimlane configurations
export const DIAGRAM_SWIMLANES: Record<string, SwimlaneConfig[]> = {
  "hardcoded-p2p-001": p2pSwimlanes,
  "hardcoded-o2c-001": o2cSwimlanes,
  "hardcoded-it-access-001": itAccessSwimlanes,
  "hardcoded-icfr-001": [], // No swimlanes for ICFR architecture diagram
  "hardcoded-gov-001": [], // No swimlanes for governance structure diagram
};
